import { getRegion } from '@/_helper/bookingDetailsHelper';
import HeroTeaser from '@/comp/heroTeaser';
import { AppContext } from '@/context/AppContext';
import { ReactNode, useContext, useMemo } from 'react';
import useNavigationList from '@/hooks/use_navigation_list.hook';
import { Icon } from '@/comp/icon/icon';

import { NavLink } from 'react-router';

import './sidenav.scss';

export const SideNavigation = ({
    children,
    alert,
}: {
    alert: {
        alertCount: {
            manageBooking: number | false;
            payment: number | false;
        };
        alertTotalCount: number;
    };
    currentStep: number;
    children?: ReactNode;
}) => {
    const { constants, travelType, bookingData, bookingState } = useContext(AppContext);
    const navigationList = useNavigationList(alert);

    const bookingNumber = useMemo(() => bookingData?.bookingId, [bookingData]);

    if (!navigationList || !bookingData) {
        return null;
    }
    const { data } = bookingData;

    return (
        <div className="side-navigation">
            <div className="side-navigation-head">
                <h1>
                    {constants?.MY_TRIP}{' '}
                    {(travelType === 'package' || travelType === 'hotel') &&
                        getRegion(data.frontendParams.hotelDetails)}
                </h1>
                <span className="booking-number">Buchungsnummer {bookingNumber}</span>
                <HeroTeaser
                    state="customerarea"
                    effect="blur"
                    bookingState={bookingState}
                    depDate={data.searchParams?.depDate}
                />
            </div>

            {children}

            <div className="side-navigation-body">
                {navigationList.map((item) => (
                    <NavLink
                        key={item.index}
                        className={({ isActive }) => `tab ${isActive && 'active'}`}
                        to={`/${item.name}`}>
                        <Icon className="tab-icon" name={item.icon} size={22} ariaHidden />
                        <span className="title">{item?.label}</span>
                        {!!item?.alertCount && <span className="alert-count">{item.alertCount}</span>}
                        {item.iconAfter && <Icon name={item.iconAfter} size={28} className="icon-after" ariaHidden />}
                        {window.$browserInfo.device === 'mobile' && (
                            <>
                                <Icon name="arrowForwardIos" size={28} ariaHidden />
                            </>
                        )}
                    </NavLink>
                ))}
            </div>
        </div>
    );
};
